// import { motion } from "framer-motion";

// const primaryValues = [
//   {
//     title: "Engineering over hype",
//     desc: "We solve problems with systems, not slogans. Code quality and architecture come first.",
//   },
//   {
//     title: "Ownership is default",
//     desc: "Every engineer owns what they ship — reliability, performance, and long-term maintainability.",
//   },
// ];

// const secondaryValues = [
//   {
//     title: "Scale is a responsibility",
//     desc: "We design systems assuming success — performance, security, and extensibility are non-negotiable.",
//   },
//   {
//     title: "Clarity beats cleverness",
//     desc: "Readable code, clear decisions, and simple abstractions outperform complexity every time.",
//   },
// ];

// const Culture = () => {
//   return (
//     <section className="pt-28 md:pt-32 md:py-14 lg:py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-6">

//         {/* TOP BLOCK */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">

//           {/* LEFT */}
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5 }}
//           >
//             <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
//               Culture is not benefits.
//               <br />
//               <span className="text-[#4F46E5]">
//                 It’s how we build software.
//               </span>
//             </h2>

//             <p className="mt-6 text-lg text-gray-600 max-w-xl">
//               Valsco Technology is built by engineers who value clean architecture,
//               system thinking, and software that survives real-world scale.
//             </p>

//             {/* PRIMARY VALUES */}
//             <div className="mt-10 space-y-6">
//               {primaryValues.map((item, i) => (
//                 <div key={i} className="border-l-4 border-[#4F46E5] pl-4">
//                   <h4 className="text-base font-semibold text-gray-900">
//                     {item.title}
//                   </h4>
//                   <p className="text-sm text-gray-600 mt-1">
//                     {item.desc}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </motion.div>

//           {/* RIGHT – IMAGE */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.96 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5 }}
//             className="relative"
//           >
//             <div className="rounded-[28px] overflow-hidden border border-gray-200 shadow-xl">
//               <img
//                 src="/culture-valsco.png"
//                 alt="Valsco engineering culture"
//                 className="w-full h-full object-cover"
//               />
//             </div>

//             <div className="absolute -bottom-5 left-6 bg-white px-4 py-2 rounded-xl shadow-md text-sm font-medium">
//               Built by engineers, for scale
//             </div>
//           </motion.div>
//         </div>

//         {/* SECONDARY VALUES */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {secondaryValues.map((item, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: index * 0.1 }}
//               className="p-8 rounded-2xl border border-gray-200 bg-gray-50"
//             >
//               <h4 className="text-lg font-semibold text-gray-900 mb-2">
//                 {item.title}
//               </h4>
//               <p className="text-sm text-gray-600 leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default Culture;

































// import { motion } from "framer-motion";

// const primaryValues = [
//   {
//     title: "Engineering over hype",
//     desc: "We solve problems with systems, not slogans. Code quality and architecture come first.",
//   },
//   {
//     title: "Ownership is default",
//     desc: "Every engineer owns what they ship — reliability, performance, and long-term maintainability.",
//   },
// ];

// const secondaryValues = [
//   {
//     title: "Scale is a responsibility",
//     desc: "We design systems assuming success — performance, security, and extensibility are non-negotiable.",
//   },
//   {
//     title: "Clarity beats cleverness",
//     desc: "Readable code, clear decisions, and simple abstractions outperform complexity every time.",
//   },
// ];

// const Culture = () => {
//   return (
//     <section className="pt-32 pb-16 md:pt-30 md:pb-20 lg:pt-32 lg:pb-24 bg-white">
//       <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">

//         {/* TOP BLOCK */}
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 md:gap-16 items-center mb-16 md:mb-20">

//           {/* LEFT */}
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5 }}
//           >
//             <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
//               Culture is not benefits.
//               <br />
//               <span className="text-[#4F46E5]">
//                 It’s how we build software.
//               </span>
//             </h2>

//             <p className="mt-5 md:mt-6 text-base md:text-lg text-gray-600 max-w-xl">
//               Valsco Technology is built by engineers who value clean architecture,
//               system thinking, and software that survives real-world scale.
//             </p>

//             {/* PRIMARY VALUES */}
//             <div className="mt-8 md:mt-10 space-y-5 md:space-y-6">
//               {primaryValues.map((item, i) => (
//                 <div key={i} className="border-l-4 border-[#4F46E5] pl-4">
//                   <h4 className="text-base font-semibold text-gray-900">
//                     {item.title}
//                   </h4>
//                   <p className="text-sm text-gray-600 mt-1">
//                     {item.desc}
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </motion.div>

//           {/* RIGHT – IMAGE */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.96 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.5 }}
//             className="relative mt-8 lg:mt-0"
//           >
//             <div className="rounded-[28px] overflow-hidden border border-gray-200 shadow-xl">
//               <img
//                 src="/culture-valsco.png"
//                 alt="Valsco engineering culture"
//                 className="w-full h-full object-cover"
//               />
//             </div>

//             <div className="absolute -bottom-5 left-6 bg-white px-4 py-2 rounded-xl shadow-md text-sm font-medium">
//               Built by engineers, for scale
//             </div>
//           </motion.div>
//         </div>

//         {/* SECONDARY VALUES */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
//           {secondaryValues.map((item, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: index * 0.1 }}
//               className="p-6 md:p-8 rounded-2xl border border-gray-200 bg-gray-50"
//             >
//               <h4 className="text-lg font-semibold text-gray-900 mb-2">
//                 {item.title}
//               </h4>
//               <p className="text-sm text-gray-600 leading-relaxed">
//                 {item.desc}
//               </p>
//             </motion.div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default Culture;






























import { motion } from "framer-motion";

const primaryValues = [
  {
    title: "Engineering over hype",
    desc: "We solve problems with systems, not slogans. Code quality and architecture come first.",
  },
  {
    title: "Ownership is default",
    desc: "Every engineer owns what they ship — reliability, performance, and long-term maintainability.",
  },
];

const secondaryValues = [
  {
    title: "Scale is a responsibility",
    desc: "We design systems assuming success — performance, security, and extensibility are non-negotiable.",
  },
  {
    title: "Clarity beats cleverness",
    desc: "Readable code, clear decisions, and simple abstractions outperform complexity every time.",
  },
];

const Culture = () => {
  return (
    <section className="pt-32 pb-16 md:pt-30 md:pb-20 lg:pt-32 lg:pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">

        {/* TOP BLOCK */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 md:gap-16 items-center mb-16 md:mb-20">

          {/* LEFT */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
              Culture is not benefits.
              <br />
              <span className="text-[#4F46E5]">
                It’s how we build software.
              </span>
            </h2>

            <p className="mt-5 md:mt-6 text-base md:text-lg text-gray-600 max-w-xl">
              Valsco Technology is built by engineers who value clean architecture,
              system thinking, and software that survives real-world scale.
            </p>

            {/* PRIMARY VALUES */}
            <div className="mt-8 md:mt-10 space-y-5 md:space-y-6">
              {primaryValues.map((item, i) => (
                <div key={i} className="border-l-4 border-[#4F46E5] pl-4">
                  <h4 className="text-base font-semibold text-gray-900">
                    {item.title}
                  </h4>
                  <p className="text-sm text-gray-600 mt-1">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>

          {/* RIGHT – IMAGE */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="relative mt-8 lg:mt-0"
          >
            <div className="rounded-[28px] overflow-hidden border border-gray-200 shadow-xl">
              <img
                src="/culture-valsco.png"
                alt="Valsco engineering culture"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="absolute -bottom-5 left-6 bg-white px-4 py-2 rounded-xl shadow-md text-sm font-medium">
              Built by engineers, for scale
            </div>
          </motion.div>
        </div>

        {/* SECONDARY VALUES */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {secondaryValues.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="p-6 md:p-8 rounded-2xl border border-gray-200 bg-gray-50"
            >
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                {item.title}
              </h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Culture;
